import {
  Columns,
  FoldPanel,
  HomeTitle,
  PreviewCard,
  AmbientParticles,
  Specimens,
} from '@src/components';

export function HomeSection() {
  return (
    <FoldPanel
      id="home"
      title="Home"
      hint="Landing pieces supplied by the active seasonal package. Particles stay inside their container."
      example={`<HomeTitle name="secret santa" title="Free Online Gift Exchange Organizer" />

<PreviewCard tone="support" step={1} title="Create a game">
  Name it after the group.
</PreviewCard>`}
    >
      <Specimens
        label="Title"
        note="One H1: the wordmark, then the organizer line as title/section."
      >
        <HomeTitle name="secret santa" title="Free Online Gift Exchange Organizer" />
      </Specimens>

      <Specimens
        label="Preview card"
        note="Numbered title and body with seasonal edges. Tone paints the disc and the title."
      >
        <Columns columns="fill" gap={5}>
          <PreviewCard tone="support" step={1} title="Create a game">
            Name it after the group — “Flat 4B” or “Tuesday quiz”.
          </PreviewCard>
          <PreviewCard tone="accent" step={2} title="Run the draw">
            Invite everyone with a link, then start the draw.
          </PreviewCard>
          <PreviewCard tone="info" step={3} title="Follow the game">
            Watch statuses and help in chat if anyone gets stuck.
          </PreviewCard>
        </Columns>
      </Specimens>

      <Specimens
        label="AmbientParticles"
        note="Home clips this to the hero. contained is the same edges in a sky box."
      >
        <AmbientParticles contained />
      </Specimens>
    </FoldPanel>
  );
}
